function extractColumnKeys (columns) {
  return (columns || []).map(col => {
    const meta = (col.MetaData || []).find(m => m.Name === 'ColKey')
    return meta?.Value || col.ColType?.toLowerCase() || 'unknown'
  })
}

function extractValues (colData, columnKeys) {
  const values = {}
  for (let i = 1; i < columnKeys.length; i++) {
    const raw = colData?.[i]?.value
    values[columnKeys[i]] = (raw != null && raw !== '') ? parseFloat(raw) : null
  }
  return values
}

function normalizeRow (row, columnKeys) {
  if (row.type === 'Data') {
    return {
      label: row.ColData?.[0]?.value ?? '',
      values: extractValues(row.ColData, columnKeys),
      rowType: 'data',
      accountId: row.ColData?.[0]?.id || null,
      group: row.group || null,
      data: undefined
    }
  }

  const hasHeader = !!row.Header
  const hasChildren = !!row.Rows?.Row?.length
  const hasSummary = !!row.Summary

  if (!hasHeader && !hasChildren && hasSummary) {
    return {
      label: row.Summary.ColData?.[0]?.value ?? '',
      values: extractValues(row.Summary.ColData, columnKeys),
      rowType: 'computed',
      accountId: null,
      group: row.group || null,
      data: undefined
    }
  }

  const children = hasChildren
    ? row.Rows.Row.map(child => normalizeRow(child, columnKeys))
    : []

  if (hasSummary) {
    children.push({
      label: row.Summary.ColData?.[0]?.value ?? '',
      values: extractValues(row.Summary.ColData, columnKeys),
      rowType: 'summary',
      accountId: null,
      group: null,
      data: undefined
    })
  }

  return {
    label: hasHeader ? (row.Header.ColData?.[0]?.value ?? '') : (row.Summary?.ColData?.[0]?.value ?? ''),
    values: hasHeader ? extractValues(row.Header.ColData, columnKeys) : {},
    rowType: 'header',
    accountId: hasHeader ? (row.Header.ColData?.[0]?.id || null) : null,
    group: row.group || null,
    data: children.length ? children : undefined
  }
}

export default function normalizeQuickBooksReport (reportData) {
  if (!reportData) return null

  const header = reportData.Header || {}
  const columnDefs = reportData.Columns?.Column || []
  const columnKeys = extractColumnKeys(columnDefs)

  const columns = columnDefs.map((col, i) => ({
    key: columnKeys[i],
    type: col.ColType,
    title: col.ColTitle || ''
  }))

  const topRows = reportData.Rows?.Row || []
  const rows = topRows.map(row => normalizeRow(row, columnKeys))

  return {
    reportName: header.ReportName || '',
    reportBasis: header.ReportBasis || '',
    currency: header.Currency || 'USD',
    startPeriod: header.StartPeriod || '',
    endPeriod: header.EndPeriod || '',
    accountingStandard: (header.Option || []).find(o => o.Name === 'AccountingStandard')?.Value || '',
    noReportData: (header.Option || []).find(o => o.Name === 'NoReportData')?.Value === 'true',
    columns,
    rows
  }
}
